if (!customElements.get("confirm-modal")) {
  // Fallback used when component-popup-manager.js was not loaded: every claim
  // succeeds, so popups behave exactly as they did before queueing existed.
  const NO_MANAGER = {
    isBusy: () => false,
    claim: () => true,
    release: () => {},
    enqueue: () => false,
    enableDebug: () => {},
  };

  const popupManager = () => window.themePopupManager || NO_MANAGER;

  class ConfirmModal extends HTMLElement {
    static getOpenModal() {
      return document.querySelector("confirm-modal[open]");
    }

    constructor() {
      super();
      this.debug = this.getAttribute("data-debug");
      this.id = this.getAttribute("id");
      this.show = parseInt(this.getAttribute("data-show"));

      this.isOpen = false;
      this._hideTimer = null;

      if (this.debug) popupManager().enableDebug();

      this.style.setProperty("display", "none");

      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this),
      );

      const self = this;

      this.tryToOpen();
    }

    open() {
      console.log('Opening confirm modal with ID:', this.id);
      if (this.isOpen) {
        return;
      }
      // A confirmation follows the visitor's own submission, so it takes the open
      // slot outright — the manager closes the popup that was using it.
      if (!popupManager().claim(this, { force: true })) {
        return;
      }
      this.setStorage();
      this.style.removeProperty("display");
      this.isOpen = true;
      document.body.classList.add("overflow-hidden");
      // Close any straggler the manager did not hold the slot for, before
      // taking the focus trap.
      document.querySelectorAll("auto-modal[open]").forEach((autoModal) => {
        autoModal.hide();
      });
      this.setAttribute("open", "");
      trapFocus(this, this.querySelector(".modal-content"));
      // window.pauseAllMedia();
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "CONFIRM-MODAL") this.hide();
      });
    }

    hide() {
      const wasOpen = this.isOpen;
      this.isOpen = false;
      document.body.classList.remove("overflow-hidden");
      this.removeAttribute("open");
      // window.pauseAllMedia();
      if (wasOpen && typeof removeTrapFocus === "function") removeTrapFocus();
      document.querySelectorAll("auto-modal[open]").forEach((autoModal) => {
        autoModal.hide();
      });

      if (this._hideTimer) window.clearTimeout(this._hideTimer);
      this._hideTimer = window.setTimeout(() => {
        this._hideTimer = null;
        this.style.setProperty("display", "none");
      }, 1000);

      // Hands the slot back and starts the countdown to the next queued popup.
      popupManager().release(this);
    }

    tryToOpen() {
      const now = new Date();

      const params = new URLSearchParams(window.location.search);
      if (params.has("openConfirmPopup")) {
        this.open();
        return;
      }
    
      if (params.has("customer_posted")) {
        const alreadyOpenConfirm = ConfirmModal.getOpenModal();
        if (alreadyOpenConfirm && alreadyOpenConfirm !== this) {
          console.log('Another confirm modal is already open, not opening this one.');
          return;
        }

        const targetId = window.sessionStorage.getItem("confirm-modal-target");
        if (targetId && this.id !== targetId) {
          console.log('Target ID from session storage:', targetId);
          return;
        }

        console.log('Checking localStorage for confirm modal timing:', this.id, localStorage.getItem(this.id + "-confirm"));

        if (
          !localStorage.getItem(this.id + "-confirm") ||
          parseInt(localStorage.getItem(this.id + "-confirm")) <= now.getTime()
        ) {
          console.log('Opening confirm modal based on localStorage timing:', this.id);
          this.open();
        }

        if (targetId && this.id === targetId) {
          window.sessionStorage.removeItem("confirm-modal-target");
        }
        if (this.debug) {
          this.open();
        }
        return;
      }
    
    }

    setStorage() {
      //We want to hide the signup popup as well
      const now = new Date();
      localStorage.setItem(this.id, now.getTime() + this.show * 60 * 60 * 1000);
      localStorage.setItem(
        this.id + "-confirm",
        now.getTime() + this.show * 60 * 60 * 1000,
      );
    }
  }
  customElements.define('confirm-modal', ConfirmModal);
}
